export const getCellValue = (row: unknown[], index: number) => {
  const value = row[index];

  return value === undefined || value === null ? '' : value;
};